import PANEL_CONFIG from './PanelTypesConfig';
import template from './panelHeader.html';

/* @ngInject */
function PanelHeaderController(
  $element,
  $state,
  appConfig
) {
  const vm = this;

  vm.setActiveEquipment  = setActiveEquipment;
  vm.checkActiveEqSelect = checkActiveEqSelect;
  vm.getPanelName        = getPanelName;
  vm.getDisplayName      = getDeviceName;
  vm.getTooltip          = getTooltip;
  vm.getBodyElement      = () => [...$element[0].parentElement.children].slice(-1);

  /** Type of panel, shown to the user as a default panel.name */
  let panelNameDefault;

  vm.$onChanges = ({ activeObjectId, panel }) => {
    if (!panelNameDefault && panel?.currentValue) {
      panelNameDefault = PANEL_CONFIG[panel.currentValue.type].prettyName;
    }


    if (!appConfig.user.partner) {
      return;
    }

    // Rename `Edit [Equipment]` menu shortcut
    if (activeObjectId?.currentValue) {
      const prevName = getDeviceName(activeObjectId.previousValue);
      const editEq = _.find(vm.menu, { text: `Edit ${prevName || 'equipment'}` });
      if (editEq) {
        editEq.text = `Edit ${getDeviceName(activeObjectId.currentValue)}`;
      }
      // Else, the menu option hasn't been created yet
    }

    // Add `Edit [Equipment]` menu shortcut
    if (!_.isEmpty(vm.objectModel)) {
      const editEqMenuItem = {
        text: `Edit ${getDeviceName(vm.activeObjectId) || 'equipment'}`,
        do: () => $state.go('admin.equipment.edit', { id: vm.activeObjectId })
      };
      // ? Menu option is added here as vm.objectModel binding is rarely ready within $init hook
      vm.menu = [editEqMenuItem, ...vm.menu || []];
    }
  };


  /**
   * Calls the setActiveMethod from the respective PanelCtrl for the dropdown menu.
   *
   * @param {object} item (Shape is whatever was passed in objectModel)
   */
  function setActiveEquipment(item) {
    vm.setActiveMethod()(item);
  }

  function checkActiveEqSelect() {
    return _.size(vm.objectModel) <= 1 || vm.disableActiveEqSelect;
  }

  function getPanelName() {
    return vm.panel.name || getDeviceName(vm.activeObjectId) || panelNameDefault;
  }

  /**
   * Get name of device using configured `displayName` or defaulting to device name
   *
   * @param {string} id
   * @returns {string|undefined}
   */
  function getDeviceName(id) {
    return vm.panel.config[id]?.displayName ?? vm.objectModel?.[id]?.name;
  }

  function getTooltip() {
    const shouldShowTooltip = getPanelName() !== panelNameDefault;
    return shouldShowTooltip ?
      _.compact([
        vm.panel.name,
        getDeviceName(vm.activeObjectId),
        PANEL_CONFIG[vm.panel.type].prettyName,
      ]).join('\n') :
      '';
  }

}

export default {
  name: 'panelHeader',
  template,
  controller: PanelHeaderController,
  controllerAs: 'PanelHeaderCtrl',
  bindings: {
    panel: '<',
    objectModel: '<?',
    activeObjectId: '<?',
    setActiveMethod: '&',
    menu: '<?',
    disableActiveEqSelect: '<?'
  }
};
